import React, { useState } from "react";
import { MessageSquarePlus, X } from "lucide-react";
import { toast } from "sonner";
import { useLocation } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";

export default function FeedbackButton() {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ description: "", priority: "medium", screenshot_data_url: "" });
  const location = useLocation();

  const onFile = (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    if (f.size > 1.5 * 1024 * 1024) { toast.error("Screenshot troppo grande (max 1.5MB)"); return; }
    const r = new FileReader();
    r.onload = () => setForm((s) => ({ ...s, screenshot_data_url: r.result }));
    r.readAsDataURL(f);
  };

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/feedback", { ...form, page: location.pathname, user_agent: navigator.userAgent });
      toast.success("Grazie per il feedback! Lo esamineremo al più presto.");
      setOpen(false); setForm({ description: "", priority: "medium", screenshot_data_url: "" });
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="feedback-fab"
        className="fixed bottom-5 right-5 z-40 h-11 px-4 rounded-full bg-primary text-primary-foreground shadow-lg hover:shadow-xl transition-shadow flex items-center gap-2 text-sm font-medium">
        <MessageSquarePlus className="w-4 h-4" /> Invia feedback
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="feedback-dialog">
          <DialogHeader>
            <DialogTitle>Invia feedback</DialogTitle>
          </DialogHeader>
          <div className="space-y-3 py-2">
            <div><Label className="text-xs">Descrizione *</Label><Textarea rows={5} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} placeholder="Cosa è successo? Cosa ti aspettavi?" data-testid="fb-desc" /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs">Priorità</Label>
                <Select value={form.priority} onValueChange={(v) => setForm({ ...form, priority: v })}>
                  <SelectTrigger data-testid="fb-priority"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="low">Bassa</SelectItem>
                    <SelectItem value="medium">Media</SelectItem>
                    <SelectItem value="high">Alta</SelectItem>
                    <SelectItem value="blocker">Bloccante</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div><Label className="text-xs">Pagina</Label><Input value={location.pathname} disabled /></div>
            </div>
            <div><Label className="text-xs">Screenshot (opzionale)</Label>
              <Input type="file" accept="image/*" onChange={onFile} data-testid="fb-screenshot" />
              {form.screenshot_data_url && (
                <div className="mt-2 relative inline-block">
                  <img src={form.screenshot_data_url} alt="preview" className="max-h-32 rounded-md border border-border/60" />
                  <button onClick={() => setForm({ ...form, screenshot_data_url: "" })} className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-background border border-border/60 flex items-center justify-center"><X className="w-3 h-3" /></button>
                </div>
              )}
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button>
            <Button onClick={submit} disabled={busy || !form.description.trim()} data-testid="fb-submit">{busy ? "Invio…" : "Invia"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
